/**
 * CustomerIdentification
 * Provides identity validation based off information submitted for specific customer.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AnswerRequestInterface } from '../model/models';
import { AnswersResult } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface AnswersServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Collection of generated question answers.
     * Submission of security question answers.
     * @param answerRequest 
     */
    submitIdentityQuestionAnswers(answerRequest?: AnswerRequestInterface, extraHttpRequestParams?: any): Observable<AnswersResult>;

}
